/**
 * Auth Tokens Value Object
 * Represents the authentication tokens returned by the API
 */
export class AuthTokens {
    private constructor(
        private readonly _accessToken: string,
        private readonly _refreshToken: string,
        private readonly _tokenType: string
    ) { }

    static create(props: {
        accessToken: string;
        refreshToken: string;
        tokenType: string;
    }): AuthTokens {
        return new AuthTokens(
            props.accessToken,
            props.refreshToken,
            props.tokenType
        );
    }

    get accessToken(): string {
        return this._accessToken;
    }

    get refreshToken(): string {
        return this._refreshToken;
    }

    get tokenType(): string {
        return this._tokenType;
    }

    /**
     * Get the authorization header value
     */
    getAuthorizationHeader(): string {
        return `${this._tokenType} ${this._accessToken}`;
    }
}
